module.exports = __webpack_public_path__ + "static/media/become_a_member.5dae2cd2.png";